import { commonTexts } from 'noddi-util';
import { ErrorPage } from 'noddi-web';
import { useNavigate } from 'react-router-dom';
import { getCommonTranslations } from '../../utils/commonTranslations';
import { CustomerHeaderNav } from '../Layouts/CustomerHeaderNav';

// Use layout='customer' when this page should include the customer header.
// Use layout='none' when rendered inside a route that already provides the header to avoid duplicates.
type Error404Layout = 'customer' | 'none';

export const Error404PageWithTranslations = ({ layout = 'none' }: { layout?: Error404Layout }) => {
  const { pageNotFoundHeading, pageNotFoundMessage, goBack } = getCommonTranslations();
  const errorPageTranslations = {
    pageNotFoundHeading,
    pageNotFoundMessage,
    goBack
  };

  return <Error404Page translations={errorPageTranslations} layout={layout} />;
};

interface Error404PageProps {
  translations?: {
    pageNotFoundHeading: string;
    pageNotFoundMessage: string;
    goBack: string;
  };
  layout?: Error404Layout;
}

const Error404LayoutWrapper = ({ layout, children }: { layout: Error404Layout; children: React.ReactNode }) => {
  if (layout === 'none') {
    return <>{children}</>;
  }

  return (
    <div className='min-h-screen bg-primary-background-gradient'>
      <CustomerHeaderNav />
      {children}
    </div>
  );
};

const Error404Page = ({ translations, layout = 'none' }: Error404PageProps) => {
  const navigate = useNavigate();

  const { goBack, pageNotFoundHeading, pageNotFoundMessage } = translations ?? {
    pageNotFoundHeading: commonTexts.pageNotFoundHeading,
    pageNotFoundMessage: commonTexts.pageNotFoundMessage,
    goBack: commonTexts.goBack
  };

  return (
    <Error404LayoutWrapper layout={layout}>
      <ErrorPage
        title={pageNotFoundHeading}
        description={pageNotFoundMessage}
        buttonProps={{
          buttonText: goBack,
          // oxlint-disable-next-line typescript/no-misused-promises -- ErrorPage onButtonClick is () => void; navigate(-1) returns a promise that only tracks lazy-route loading
          onButtonClick: () => navigate(-1)
        }}
      />
    </Error404LayoutWrapper>
  );
};
